import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { logout, deleteMeAction, getLoggedinUserAction, updateLoggedinUserDetails, changeLoggedInUserPasswordAction } from '../../redux/actions/userActions';
import { validateOnlyChacters, validateEmail, validatePhone, unMasking, inputPhoneMasking } from '../../utils/validators';
import {
  CHANGE_LOGGED_IN_USER_PASSWORD_RESET,
  DELETE_ME_RESET,
  GET_LOGGED_USER_DETAILS_RESET,
  UPDATE_LOGGED_USER_DETAILS_RESET,
} from '../../redux/constants/userConstants';

import Content from '../../components/Content';
import TextInput from '../LoginScreen/TextInput';
import Button from '../../components/Modal/Button';

import MyProfileStyles from './MyProfileScreen.module.css';
import EditProfileModal from './EditProfileModal';
import { useHistory, useParams } from 'react-router-dom';
import DeactiveAccountModal from './DeactiveAccountModal';
// import CancelSubscription from './CancelSubscription';

const MyProfileScreen = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [password, setPassword] = React.useState({
    value: '',
    error: '',
    validated: false,
  });
  const [passwordNew, setPasswordNew] = React.useState({
    value: '',
    error: '',
    validated: false,
  });

  const [editProfileModal, setEditProfileModal] = React.useState(false);
  const [userName, setUserName] = React.useState({ value: '', error: '' });
  const [userEmail, setUserEmail] = React.useState({ value: '', error: '' });
  const [userPhone, setUserPhone] = React.useState({ value: '', error: '' });
  const [userAddress, setUserAddress] = React.useState({
    value: '',
    error: '',
  });

  const [deactivateUserModal, setDeactivateUserModal] = React.useState(false);
  const [unsubscribeModal, setUnsubscribeModal] = React.useState(false);

  const loggedinUser = useSelector(state => state.loggedinUser);
  const orgDetails = useSelector(state => state.orgDetails);
  const loggedInUserPasswordChange = useSelector(state => state.loggedInUserPasswordChange);
  const updateLoggedInUser = useSelector(state => state.updateLoggedInUser);
  const deleteMe = useSelector(state => state.deleteMe);
  const history = useHistory();

  React.useEffect(() => {
    dispatch(getLoggedinUserAction());
  }, [dispatch]);

  React.useEffect(() => {
    if (loggedInUserPasswordChange && loggedInUserPasswordChange.userInfo && loggedInUserPasswordChange.userInfo.status === 'success') {
      dispatch(logout());
      dispatch({ type: CHANGE_LOGGED_IN_USER_PASSWORD_RESET });
      toast.success(t('screens.myProfileLegacy.toastPwChanged'));
    }
  }, [loggedInUserPasswordChange, dispatch]);

  React.useEffect(() => {
    if (loggedinUser && loggedinUser.userInfo && loggedinUser.userInfo.data && loggedinUser.userInfo.data.user) {
      setUserName({ value: loggedinUser.userInfo.data.user.name, error: '' });
      setUserEmail({ value: loggedinUser.userInfo.data.user.email, error: '' });
      setUserPhone({ value: inputPhoneMasking(loggedinUser.userInfo.data.user.phone), error: '' });
      setUserAddress({
        value: loggedinUser.userInfo.data.user.address,
        error: '',
      });
    }
    // history.replace('/chat');
    // setTimeout(() =>{
    //   window.location.reload();
    // }, 1000)
  }, [loggedinUser]);

  React.useEffect(() => {
    if (updateLoggedInUser && updateLoggedInUser.userInfo && updateLoggedInUser.userInfo.status === 'success') {
      handleModalClose();
      dispatch(getLoggedinUserAction());
      dispatch({ type: UPDATE_LOGGED_USER_DETAILS_RESET });
      toast.success(t('screens.myProfileLegacy.toastProfileUpdated'));
    }
  }, [updateLoggedInUser, dispatch]);

  React.useEffect(() => {
    if (deleteMe && deleteMe.success) {
      dispatch({ type: DELETE_ME_RESET });
      dispatch(logout());
      toast.error(t('screens.myProfileLegacy.toastAccountDeactivated'));
    }
  }, [deleteMe, dispatch]);

  const handleChangePassword = () => {
    if (password.value === '' || password.value.trim() === '') {
      setPassword({
        ...password,
        error: t('screens.myProfileLegacy.errCurrentPw'),
        validated: false,
      });
    } else if (password.value.length < 8) {
      setPassword({
        ...password,
        error: t('screens.myProfileLegacy.errPwLen'),
        validated: false,
      });
    } else if (passwordNew.value === '' || passwordNew.value.trim() === '') {
      setPasswordNew({
        ...passwordNew,
        error: t('screens.myProfileLegacy.errNewPw'),
        validated: false,
      });
    } else if (passwordNew.value.length < 8) {
      setPasswordNew({
        ...passwordNew,
        error: t('screens.myProfileLegacy.errPwLen'),
        validated: false,
      });
    } else {
      dispatch(changeLoggedInUserPasswordAction(password.value, passwordNew.value));
    }
  };

  const handleModalClose = () => {
    setEditProfileModal(false);
    // setUserName({ value: '', error: '' });
    // setUserEmail({ value: '', error: '' });
    // setUserPhone({ value: '', error: '' });
    // setUserAddress({ value: '', error: '' });
  };

  const handleEditProfile = () => {
    if (userName.value === '' || userName.value.trim() === '') {
      setUserName({ ...userName, error: t('screens.myProfileLegacy.errName') });
    } else if (!validateOnlyChacters(userName.value)) {
      setUserName({ ...userName, error: t('screens.myProfileLegacy.errNameAlpha') });
    } else if (userEmail.value === '' || userEmail.value.trim() === '' || !validateEmail(userEmail.value)) {
      setUserEmail({ ...userEmail, error: t('screens.myProfileLegacy.errEmail') });
    } else if (userPhone.value !== '' && !validatePhone(unMasking(userPhone.value))) {
      setUserPhone({ ...userPhone, error: t('screens.myProfileLegacy.errPhone') });
    }
    //else if (userAddress.value === '' || userAddress.value.trim() === '') {
    //   setUserAddress({ ...userAddress, error: 'Please enter your address' });
    // }
    else {
      dispatch(
        updateLoggedinUserDetails({
          name: userName.value,
          email: userEmail.value,
          phone: unMasking(userPhone.value),
          address: userAddress.value,
        })
      );
    }
  };

  const handleDeactivateUser = () => {
    if (loggedinUser && loggedinUser.userInfo && loggedinUser.userInfo.data && loggedinUser.userInfo.data.user && loggedinUser.userInfo.data.user.role === 'admin') {
      alert(t('screens.myProfileLegacy.cannotDeactivateAdmin'));
    } else {
      dispatch(deleteMeAction());
    }
  };

  // const handleUnsubscribeClient = () => {
  //   if (
  //     loggedinUser &&
  //     loggedinUser.userInfo &&
  //     loggedinUser.userInfo.data &&
  //     loggedinUser.userInfo.data.user &&
  //     (loggedinUser.userInfo.data.user.role === 'fileAdmin' || loggedinUser.userInfo.data.user.role === 'org')
  //   ) {
  //     dispatch(unsubscribeClientAction());
  //   } else {
  //     alert('You can not permission to perform this action.');
  //   }
  // };

  console.log(loggedinUser);
  

  return (
    <Content headerTitle={t('screens.myProfileLegacy.title')} currentMenu='profile'>
      {loggedinUser && loggedinUser.loading
        ? null
        : loggedinUser &&
          loggedinUser.userInfo &&
          loggedinUser.userInfo.data &&
          loggedinUser.userInfo.data.user && (
            <div className={MyProfileStyles.content}>
              <div className={MyProfileStyles.content_left}>
                <div>
                  <svg className={MyProfileStyles.content_left_profile_image}>
                    <use xlinkHref={`/assets/sprite.svg#icon-user-circle-o`} />
                  </svg>
                  <h2 className={MyProfileStyles.content_left_profile_name}>{loggedinUser.userInfo.data.user.name}</h2>
                  <p className={MyProfileStyles.content_left_profile_role}>
                    {t('screens.myProfileLegacy.loggedInWith', { role:
                      loggedinUser.userInfo.data.user.role && loggedinUser.userInfo.data.user.role === 'fileUserOnlyDownload'
                        ? t('screens.myProfileLegacy.roleFileUserRO')
                        : loggedinUser.userInfo.data.user.role.startsWith('file')
                        ? 'File ' + loggedinUser.userInfo.data.user.role.split('file')[1]
                        : loggedinUser.userInfo.data.user.role.slice(0, 1).toUpperCase() + loggedinUser.userInfo.data.user.role.slice(1)
                    })}
                  </p>

                  <div className={MyProfileStyles.content_left_contacts}>
                    {loggedinUser.userInfo.data.user.phone ? <div className={MyProfileStyles.content_left_contact}>
                      <div className={MyProfileStyles.content_left_contact_box + ' ' + MyProfileStyles.content_left_contact_box_red}>
                        <svg className={MyProfileStyles.content_left_contact_box_icon}>
                          <use xlinkHref={`/assets/sprite.svg#icon-mobile`} />
                        </svg>
                      </div>
                      <div className={MyProfileStyles.content_left_contact_data}>
                        <p className={MyProfileStyles.content_left_contact_data_title}>{t('screens.myProfileLegacy.phone')}</p>
                        <p className={MyProfileStyles.content_left_contact_data_field}>{inputPhoneMasking(loggedinUser.userInfo.data.user.phone)}</p>
                      </div>
                    </div> : null}

                    <div className={MyProfileStyles.content_left_contact}>
                      <div className={MyProfileStyles.content_left_contact_box + ' ' + MyProfileStyles.content_left_contact_box_blue}>
                        <svg className={MyProfileStyles.content_left_contact_box_icon}>
                          <use xlinkHref={`/assets/sprite.svg#icon-email`} />
                        </svg>
                      </div>
                      <div className={MyProfileStyles.content_left_contact_data}>
                        <p className={MyProfileStyles.content_left_contact_data_title}>{t('screens.myProfileLegacy.email')}</p>
                        <p className={MyProfileStyles.content_left_contact_data_field}>{loggedinUser.userInfo.data.user.email}</p>
                      </div>
                    </div>

                    {loggedinUser.userInfo.data.user.address ? <div className={MyProfileStyles.content_left_contact}>
                      <div className={MyProfileStyles.content_left_contact_box + ' ' + MyProfileStyles.content_left_contact_box_primary}>
                        <svg className={MyProfileStyles.content_left_contact_box_icon}>
                          <use xlinkHref={`/assets/sprite.svg#icon-map-pin`} />
                        </svg>
                      </div>
                      <div className={MyProfileStyles.content_left_contact_data}>
                        <p className={MyProfileStyles.content_left_contact_data_title}>{t('screens.myProfileLegacy.address')}</p>
                        <p className={MyProfileStyles.content_left_contact_data_field}>{loggedinUser.userInfo.data.user.address}</p>
                      </div>
                    </div> : null}
                  </div>
                </div>

                <div className={MyProfileStyles.content_left_bottom}>
                  <Button label={t('screens.myProfileLegacy.editProfile')} span={false} style={{ justifyContent: 'center' }} onClick={() => setEditProfileModal(true)} />

                  {loggedinUser &&
                    loggedinUser.userInfo &&
                    loggedinUser.userInfo.data &&
                    loggedinUser.userInfo.data.user &&
                    loggedinUser.userInfo.data.user.role !== 'admin' && (
                      <button className={MyProfileStyles.userDetails__deatctivateButton} onClick={() => setDeactivateUserModal(true)}>
                        {t('screens.myProfileLegacy.deactivate')}
                      </button>
                    )}
                </div>
              </div>

              <div className={MyProfileStyles.content_right}>
                <div className={MyProfileStyles.changePasswordSection}>
                  <div className={MyProfileStyles.changePasswordSection_left}>
                    <h2 className={MyProfileStyles.changePasswordSection_heading}>{t('screens.myProfileLegacy.changePassword')}</h2>
                    <TextInput
                      type='password'
                      label={t('screens.myProfileLegacy.currentPassword')}
                      placeholder={t('screens.myProfileLegacy.currentPasswordPh')}
                      icon='key'
                      onChange={e => {
                        if (e.target.value.length > 7) {
                          setPassword({
                            value: e.target.value,
                            validated: true,
                          });
                        } else {
                          setPassword({
                            value: e.target.value,
                            validated: false,
                          });
                        }
                      }}
                      validated={password.validated}
                      errorMessage={password.error}
                      light={false}
                    />
                    <TextInput
                      type='password'
                      label={t('screens.myProfileLegacy.newPassword')}
                      placeholder={t('screens.myProfileLegacy.newPasswordPh')}
                      icon='key'
                      onChange={e => {
                        if (e.target.value.length > 7) {
                          setPasswordNew({
                            value: e.target.value,
                            validated: true,
                          });
                        } else {
                          setPasswordNew({
                            value: e.target.value,
                            validated: false,
                          });
                        }
                      }}
                      validated={passwordNew.validated}
                      errorMessage={passwordNew.error}
                      light={false}
                    />
                    <Button label={t('screens.myProfileLegacy.changePasswordBtn')} style={{ alignSelf: 'flex-start' }} onClick={handleChangePassword} />
                  </div>

                  <div className={MyProfileStyles.changePasswordSection_right}>
                    <p className={MyProfileStyles.changePasswordSection_text}>{t('screens.myProfileLegacy.passwordAdvice1')}</p>
                    <p className={MyProfileStyles.changePasswordSection_text}>
                      {t('screens.myProfileLegacy.passwordAdvice2')}
                    </p>
                  </div>
                </div>

                {loggedinUser.userInfo.data.user.role === 'org' && (
                  <Fragment>
                    {loggedinUser.userInfo.data.user.customClient ? (
                      <div className={MyProfileStyles.planDetailsSection}>
                        <div>
                          <h2 className={MyProfileStyles.changePasswordSection_heading}>{t('screens.myProfileLegacy.yourPlan')}</h2>

                          <div className={MyProfileStyles.planDetailsSection_content}>
                            <h5 className={MyProfileStyles.planDetailsSection_price}>{loggedinUser.userInfo.data.user.name}</h5>
                            <h5 className={MyProfileStyles.planDetailsSection_price}>
                              <span>{t('screens.myProfileLegacy.subscribedOn', { date: new Date(loggedinUser.userInfo.data.user.onBoardOn).toDateString() })}</span>
                            </h5>

                            <div className={MyProfileStyles.planDetailsSection_feature}>
                              <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                  <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                </svg>
                              </div>
                              <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                {t('screens.myProfileLegacy.gbStorage', { n: loggedinUser.userInfo.data.user.customClientDetails?.space })}
                              </p>
                            </div>

                            <div className={MyProfileStyles.planDetailsSection_feature}>
                              <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                  <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                </svg>
                              </div>
                              <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                {t('screens.myProfileLegacy.adminUsersCount', { n: loggedinUser.userInfo.data.user.customClientDetails?.adminUsers })}
                              </p>
                            </div>

                            <div className={MyProfileStyles.planDetailsSection_feature}>
                              <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                  <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                </svg>
                              </div>
                              <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                {t('screens.myProfileLegacy.readOnlyUsersCount', { n: loggedinUser.userInfo.data.user.customClientDetails?.downloadUsers })}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </Fragment>
                )}
                {loggedinUser.userInfo.data.user.role === 'fileAdmin' && (
                  <Fragment>
                    {
                      loggedinUser.userInfo.data.user.org.customClient ? (
                        <div className={MyProfileStyles.planDetailsSection}>
                          <div>
                            <h2 className={MyProfileStyles.changePasswordSection_heading}>{t('screens.myProfileLegacy.yourPlan')}</h2>

                            <div className={MyProfileStyles.planDetailsSection_content}>
                              <h5 className={MyProfileStyles.planDetailsSection_price}>{loggedinUser.userInfo.data.user.org.name}</h5>
                              <h5 className={MyProfileStyles.planDetailsSection_price}>
                                <span>{t('screens.myProfileLegacy.subscribedOn', { date: new Date(loggedinUser.userInfo.data.user.org.onBoardOn).toDateString() })}</span>
                              </h5>

                              <div className={MyProfileStyles.planDetailsSection_feature}>
                                <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                  <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                    <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                  </svg>
                                </div>
                                <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                  {t('screens.myProfileLegacy.gbStorage', { n: loggedinUser.userInfo.data.user.org.customClientDetails?.space })}
                                </p>
                              </div>

                              <div className={MyProfileStyles.planDetailsSection_feature}>
                                <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                  <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                    <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                  </svg>
                                </div>
                                <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                  {t('screens.myProfileLegacy.adminUsersCount', { n: loggedinUser.userInfo.data.user.org.customClientDetails?.adminUsers })}
                                </p>
                              </div>

                              <div className={MyProfileStyles.planDetailsSection_feature}>
                                <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                                  <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                                    <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                                  </svg>
                                </div>
                                <p className={MyProfileStyles.planDetailsSection_feature_text}>
                                  {t('screens.myProfileLegacy.readOnlyUsersCount', { n: loggedinUser.userInfo.data.user.org.customClientDetails?.downloadUsers })}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )
                      //   (
                      //     orgDetails &&
                      //     orgDetails.details &&
                      //     orgDetails.details.package &&
                      //     orgDetails.details.package.metadata && (
                      //       <div className={MyProfileStyles.planDetailsSection}>
                      //         <div>
                      //           <h2 className={MyProfileStyles.changePasswordSection_heading}>Your plan details</h2>

                      //           <div className={MyProfileStyles.planDetailsSection_content}>
                      //             <h5 className={MyProfileStyles.planDetailsSection_price}>
                      //               {orgDetails.details.package.name}{' '}
                      //               <span>
                      //                 $ {orgDetails.details.plan.amount} per {orgDetails.details.plan.interval}
                      //               </span>
                      //             </h5>
                      //             <h5 className={MyProfileStyles.planDetailsSection_price}>
                      //               <span>Subscribed on: {new Date(orgDetails.details.onBoardOn).toDateString()}</span>
                      //             </h5>

                      //             <div className={MyProfileStyles.planDetailsSection_feature}>
                      //               <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                      //                 <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                      //                   <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                      //                 </svg>
                      //               </div>
                      //               <p className={MyProfileStyles.planDetailsSection_feature_text}>{orgDetails.details.package.description}</p>
                      //             </div>
                      //             <div className={MyProfileStyles.planDetailsSection_feature}>
                      //               <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                      //                 <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                      //                   <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                      //                 </svg>
                      //               </div>
                      //               <p className={MyProfileStyles.planDetailsSection_feature_text}>{orgDetails.details.package.metadata.space} GB dedicated storage</p>
                      //             </div>
                      //             <div className={MyProfileStyles.planDetailsSection_feature}>
                      //               <div className={MyProfileStyles.planDetailsSection_feature_icon_box}>
                      //                 <svg className={MyProfileStyles.loginContainer_textBox_icon}>
                      //                   <use xlinkHref={`/assets/sprite.svg#icon-check`} />
                      //                 </svg>
                      //               </div>
                      //               <p className={MyProfileStyles.planDetailsSection_feature_text}>{orgDetails.details.package.metadata.users} users</p>
                      //             </div>
                      //           </div>
                      //         </div>

                      //         <div style={{ alignSelf: 'flex-end' }}>
                      //           <p className={MyProfileStyles.planDetailsSection_cancel_btn}>
                      //             Plan expires on {new Date(orgDetails.details.packageExpires).toDateString()}
                      //           </p>
                      //           <button className={MyProfileStyles.planDetailsSection_cancel_btn} onClick={() => setUnsubscribeModal(true)}>
                      //             Cancel your subscription
                      //           </button>
                      //         </div>
                      //       </div>
                      //     )
                      // )
                    }

                    <div className={MyProfileStyles.storageContainer}>
                      <h3 className={MyProfileStyles.changePasswordSection_heading}>{t('screens.myProfileLegacy.spaceUsed')}</h3>
                      <div className={MyProfileStyles.storageContainerLines}>
                        <div className={MyProfileStyles.storageContainerLineFull} />
                        <div
                          className={MyProfileStyles.storageContainerLineUsed}
                          style={{
                            width: `${
                              loggedinUser.userInfo.data.user.usedSpace
                                ? (Number(loggedinUser.userInfo.data.user.usedSpace) / Number(loggedinUser.userInfo.data.user.maxStorageAllowed)) * 100
                                : 0
                            }% `,
                          }}
                        />
                      </div>
                      <h4 className={MyProfileStyles.storageContainerTitle}>
                        {t('screens.myProfileLegacy.gbUsageLabel', {
                          used: loggedinUser.userInfo.data.user.usedSpace ? loggedinUser.userInfo.data.user.usedSpace.toFixed(3) : '0',
                          max: loggedinUser.userInfo.data.user.maxStorageAllowed,
                        })}
                      </h4>
                    </div>

                    {/* {loggedinUser.userInfo.data.user.role === 'org' &&
                      orgDetails &&
                      orgDetails.details &&
                      orgDetails.details.package &&
                      orgDetails.details.package.metadata && (
                        <div className={MyProfileStyles.storageContainer}>
                          <div className={MyProfileStyles.storageContainerLines}>
                            <div className={MyProfileStyles.storageContainerLineFull} />
                            <div
                              className={MyProfileStyles.storageContainerLineUsed}
                              style={{
                                width: `${(orgDetails.details.usedSpace / orgDetails.details.package.metadata.space) * 100}%`,
                              }}
                            />
                          </div>
                          <h4 className={MyProfileStyles.storageContainerTitle}>
                            {orgDetails.details.usedSpace}GB out of {orgDetails.details.package.metadata.space}GB used
                          </h4>
                        </div>
                      )} */}

                    {orgDetails && orgDetails.details && orgDetails.details.package && orgDetails.details.package.metadata && (
                      <div className={MyProfileStyles.user_used_container}>
                        <h3 className={MyProfileStyles.changePasswordSection_heading}>{t('screens.myProfileLegacy.totalUsers')}</h3>
                        <div className={MyProfileStyles.storageContainerLines}>
                          <div className={MyProfileStyles.storageContainerLineFull} />
                          {orgDetails.details.package.metadata.users === 1 ? (
                            <div className={MyProfileStyles.storageContainerLineUsed} style={{ width: '100%' }} />
                          ) : (
                            <div
                              className={MyProfileStyles.storageContainerLineUsed}
                              style={{
                                width: `${(orgDetails.details.totalResults / orgDetails.details.package.metadata.users) * 100}%`,
                              }}
                            />
                          )}
                        </div>
                        <h4 className={MyProfileStyles.storageContainerTitle}>
                          {orgDetails.details.package.metadata.users === 1
                            ? t('screens.myProfileLegacy.usersUsageOne', { max: orgDetails.details.package.metadata.users })
                            : t('screens.myProfileLegacy.usersUsage', { used: orgDetails.details.totalResults, max: orgDetails.details.package.metadata.users })}
                        </h4>
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          )}

      <EditProfileModal
        editProfileModal={editProfileModal}
        handleModalClose={handleModalClose}
        handleEditProfile={handleEditProfile}
        loading={updateLoggedInUser && updateLoggedInUser.loading}
        data={{
          userName,
          setUserName,
          userEmail,
          setUserEmail,
          userPhone,
          setUserPhone,
          userAddress,
          setUserAddress,
        }}
      />

      <DeactiveAccountModal
        deactivateUserModal={deactivateUserModal}
        loading={deleteMe && deleteMe.loading}
        handleDeactivateUserModalClose={() => setDeactivateUserModal(false)}
        handleDeactivateUser={handleDeactivateUser}
      />

      {/* <CancelSubscription
        unsubscribeModal={unsubscribeModal}
        loading={deleteMe && deleteMe.loading}
        handleUnsubscribeClientModalClose={() => setUnsubscribeModal(false)}
        handleUnsubscribeClient={handleUnsubscribeClient}
      /> */}
    </Content>
  );
};

export default MyProfileScreen;
